<template>
  <app-popup :active.sync="isActive" title="Произведенные действия" width="420px">
    <div>
      <div class="issues-app-chat-sidebar__comments issues-app-chat-sidebar-comments issues-app-chat-sidebar-comments_done">
        <div class="issues-app-chat-sidebar-comments__toolbar">
          <div :id="`toolbar-container-${_uid}`">
            <div>
              <button class="ql-bold"/>
              <button class="ql-italic"/>
              <button class="ql-underline"/>
            </div>
          </div>
        </div>

        <quill-editor :options="quillEditorOptions"
                      ref="quill"
                      v-model="message"
                      placeholder="Комментарий пуст"
        />
      </div>
    </div>
    <div style="text-align: center; margin-top: 15px">
      <app-button color="success" @click="save">Сохранить</app-button>
    </div>
  </app-popup>
</template>

<script>
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'
  import { quillEditor } from 'vue-quill-editor'

  export default {
    name: "DoneActionsPopup",
    components: {quillEditor},
    data() {
      return {
        quillEditorOptions: {
          root: {
            spellcheck: false
          },
          modules: {
            toolbar: `#toolbar-container-${this._uid}`
          },
          grammar: {
            checkSpelling: false,
          },
          spellcheck: false
        },
        isActive: false,
        message: ""
      }
    },
    methods: {
      open() {
        this.message = "";
        this.isActive = true;
      },
      save(){
        this.$emit('save', this.message);
        this.isActive = false;
      }
    }
  }
</script>

<style lang="scss">
.issues-app-chat-sidebar-comments_done{
  height: 320px!important;
}
</style>
